import React, { forwardRef, useMemo } from 'react';
import { genericMemo, mergeRefs, type DistributiveOmit } from '@direct-frontend/stdlib';
import { isMobile } from '@direct-frontend/platform-code';

import { TextInputCompact, TextInputCompactProps } from '../TextInputCompact';
import { PseudoInput } from '../PseudoInput/PseudoInput';

import { MaskedTextInputAdditionalProps } from './types';
import { useControlledMaskito } from './useControlledMaskito';

export type MaskedTextInputCompactProps = DistributiveOmit<TextInputCompactProps, 'isMaskedInput' | 'isTextarea'> &
    MaskedTextInputAdditionalProps;

/**
 * Компонент для использования TextInputCompact с маской
 */
export const MaskedTextInputCompact = genericMemo(
    forwardRef<HTMLInputElement | HTMLTextAreaElement, MaskedTextInputCompactProps>(
        function MaskedTextInputCompact(props, ref) {
            const { maskConfig, onChange, value, shouldUpdateUnmaskedValue = true, ...textInputProps } = props;

            const { ref: maskitoRef, ...maskProps } = useControlledMaskito({
                maskConfig,
                onChange,
                value,
                shouldUpdateUnmaskedValue,
            });
            const setRef = useMemo(() => mergeRefs(ref, maskitoRef), [maskitoRef, ref]);

            if (isMobile() && props.isMobileTrigger) {
                return <PseudoInput {...props} onPress={props.onMobileTriggerPress} />;
            }

            return (
                <TextInputCompact
                    {...textInputProps}
                    {...maskProps}
                    // Внутренний проп библиотеки компонентов, не удалять
                    isMaskedInput
                    ref={setRef}
                />
            );
        },
    ),
);
